"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _Utils = require("./helpers/Utils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellIcon = function CellIcon(props) {
  var data = props.data,
      header = props.header,
      width = props.width,
      headerText = props.headerText,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      sorted = props.sorted;

  if (!header && (!data || !(0, _Utils.validateString)(data.name))) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    width: width,
    sortable: sortable,
    sortOrder: sortOrder,
    sorted: sorted
  }, headerText) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    width: width,
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledCellImage, null, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    url: data.image_url,
    opacity: "0"
  })), /*#__PURE__*/_react["default"].createElement(_styled.StyledCellTextContainer, {
    withImage: true
  }, /*#__PURE__*/_react["default"].createElement(_styled.EllipsisTitle, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: data.link
  }, data.name))));
};

var _default = CellIcon;
exports["default"] = _default;

//# sourceMappingURL=CellIcon.js.map